// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PwaInstallController from "./pwa_install_controller"
application.register("pwa-install", PwaInstallController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)

import ScoreSheetController from "./score_sheet_controller"
application.register("score-sheet", ScoreSheetController)

import LiveRefreshController from "./live_refresh_controller"
application.register("live-refresh", LiveRefreshController)

import GuestRejoinController from "./guest_rejoin_controller"
application.register("guest-rejoin", GuestRejoinController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import PageRefreshController from "./page_refresh_controller"
application.register("page-refresh", PageRefreshController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)
